"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const transforms = __importStar(require("./tokens/transforms"));
const css_1 = require("./tokens/css");
const generate_1 = require("./tokens/unit/utilities/generate");
const generateMetaColors_1 = __importDefault(require("./tokens/color/utilities/generateMetaColors"));
const fn_1 = require("culori/require");
const transform = (name, definition, options) => {
    const { isFragment, themeOptions } = options;
    const generatedUnits = (0, generate_1.generateUnits)(definition);
    const generatedViewports = definition.viewport?.m?.minPx
        ? { s: { maxPx: definition.viewport.m.minPx - 1 } }
        : {};
    const generatedMetaColors = (0, generateMetaColors_1.default)(definition, themeOptions);
    const generatedColors = Object.entries({
        ...definition.color,
        ...generatedMetaColors,
    }).reduce((res, [key, token]) => {
        const next = { ...token };
        if (!token)
            return res;
        if (!token.hex && token.oklch) {
            next.hex =
                token.oklch.alpha !== undefined
                    ? (0, fn_1.formatHex8)({ ...token.oklch, mode: "oklch" })
                    : (0, fn_1.formatHex)({ ...token.oklch, mode: "oklch" });
        }
        if (!token.hexDark && token.oklchDark) {
            next.hexDark =
                token.oklchDark.alpha !== undefined
                    ? (0, fn_1.formatHex8)({ ...token.oklchDark, mode: "oklch" })
                    : (0, fn_1.formatHex)({ ...token.oklchDark, mode: "oklch" });
        }
        return { ...res, [key]: next };
    }, {});
    const theme = {
        ...definition,
        color: generatedColors,
        unit: {
            ...definition.unit,
            ...generatedUnits,
        },
        viewport: {
            ...definition.viewport,
            ...generatedViewports,
        },
    };
    const transformedStorage = {
        variable: [],
        media: [],
    };
    Object.entries(theme).forEach(([tokenType, tokenValues]) => {
        if (!tokenValues)
            return;
        const transform = transforms.css[tokenType];
        Object.entries(tokenValues).forEach(([tokenName, token]) => {
            const transformedTokens = transform(tokenName, token, {
                theme,
                themeOptions: options.themeOptions,
            });
            transformedTokens.forEach((transformedToken) => {
                transformedStorage[transformedToken.type].push(transformedToken);
            });
        });
    });
    return {
        variables: (0, css_1.variablesTemplate)(name, transformedStorage.variable),
        media: !isFragment ? (0, css_1.mediaTemplate)(transformedStorage.media) : undefined,
        theme,
    };
};
exports.default = transform;
